import { useTranslation } from 'react-i18next';

export default function useTimezone() {
  const { i18n } = useTranslation();
  const tz = new Intl.DateTimeFormat(i18n.language, {
    timeZoneName: 'shortOffset',
  });
  const timezone = tz.format(new Date()).split(' ').pop();
  return timezone;
}
